import React from 'react';
import { useTranslation } from 'react-i18next';
import { translationKeys } from '@gik/inkind-page/i18n/en';
import bemBlock from '@gik/core/utils/bemBlock';
import { PropsWithClassName } from '@gik/core/utils/ReactUtils';
import { IGenericCardProps, PrivacySettingsCard } from '@gik/inkind-page';

export const visitorsCardBlockName = 'visitors-card';

const VisitorsCard: React.FC<PropsWithClassName<IGenericCardProps>> = ({
  className,
  value,
  onChange,
  inputName,
}): JSX.Element => {
  const { t } = useTranslation();
  const bem = bemBlock(visitorsCardBlockName);

  return (
    <PrivacySettingsCard
      className={bem(null, null, className)}
      title={t(translationKeys.visitorsTitle)}
      icon={{
        set: 'gik-icons',
        name: value ? 'VisitorsOkOutline' : 'VisitorsDisabledOutline',
      }}
      description={value ? t(translationKeys.visitorsDescription) : t(translationKeys.visitorsDescriptionDisabled)}
      value={value}
      onChange={onChange}
      inputName={inputName}
    />
  );
};

export default VisitorsCard;
